  export const handleStatusChange = (setValue,selectedOption,trigger) => {
    setValue("status", selectedOption || "");
    trigger("status");
  };
  export const generatePassword = () => {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%^&*!";
  const length = Math.floor(Math.random() * (12 - 6 + 1)) + 6; // random length between 6-12
  let password = "";
  for (let i = 0; i < length; i++) {
    password += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return password;
};

export const validateExcel = (file, callback) => {
  const reader = new FileReader();

  // Check file extension first to eliminate .zip files
  const fileName = file.name.toLowerCase();
  const isXlsExtension = fileName.endsWith(".xls");
  const isXlsxExtension = fileName.endsWith(".xlsx");

  if (!isXlsExtension && !isXlsxExtension) {
    callback(false); // Invalid file if extension is not .xls or .xlsx
    return;
  }

  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16).padStart(2, "0");
    }
    header = header.toUpperCase();

    // File signature check for Excel files
    const isXls = header === "D0CF11E0"; // XLS (Excel 97-2003)
    const isXlsx = header === "504B0304"; // XLSX (Excel Open XML format)

    // Combine both checks
    const isExcel = (isXls && isXlsExtension) || (isXlsx && isXlsxExtension);

    callback(isExcel); // Callback with true if it's a valid Excel file
  };

  reader.onerror = function () {
    callback(false); // Error while reading file
  };

  reader.readAsArrayBuffer(file.slice(0, 4));
};

export const validateExcelOrCsv = (file, callback) => {
  const reader = new FileReader();
  const fileName = file.name.toLowerCase();

  const isXlsExtension = fileName.endsWith(".xls");
  const isXlsxExtension = fileName.endsWith(".xlsx");
  const isCsvExtension = fileName.endsWith(".csv");

  // If it's a CSV, accept it immediately (no need for binary check)
  if (isCsvExtension) {
    callback(true);
    return;
  }

  // If not Excel or CSV, reject
  if (!isXlsExtension && !isXlsxExtension) {
    callback(false);
    return;
  }

  reader.onloadend = function (event) {
    const arr = new Uint8Array(event.target.result).subarray(0, 4);
    let header = "";
    for (let i = 0; i < arr.length; i++) {
      header += arr[i].toString(16).padStart(2, "0");
    }
    header = header.toUpperCase();

    const isXls = header === "D0CF11E0"; // XLS
    const isXlsx = header === "504B0304"; // XLSX

    const isExcel = (isXls && isXlsExtension) || (isXlsx && isXlsxExtension);
    callback(isExcel);
  };

  reader.onerror = function () {
    callback(false);
  };

  reader.readAsArrayBuffer(file.slice(0, 4));
};

export const  hasPermission = (user, pathname, action = 'isView') => {
  if (user?.role === "admin") return true;
  const perm = user?.permissions?.find(p => p.slug === pathname);
  return perm?.[action] === true;
}


